import {WiFiInterface} from '../Types/Wifi';
import api from "./API";

export async function getWifi(): Promise<WiFiInterface[]> {
    try {
        const response = await api.get("/api/unihouse/get/wifi");
        return response.data.map((net: WiFiInterface) => ({
            SSID: net.SSID,
            PSK: net.PSK,
        }));
    } catch (error) {
        console.error(error);
        throw error;
    }
}